var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-button",class:{ 'tab-button--active': _vm.active },attrs:{"role":"button","tabindex":"0","aria-expanded":_vm.active,"aria-controls":_vm.id},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }